"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOLE_PROPRIETOR = exports.JOINT_VENTURE = exports.LIMITED_LIABILITY = exports.PARTNERSHIP = exports.INCORPORATED_BUSINESS = exports.UNINCORPORATED_BUSINESS = exports.PARTY_SUB_TYPES = void 0;

var _types = require("./types");

var PARTY_SUB_TYPES = {}; // Business

exports.PARTY_SUB_TYPES = PARTY_SUB_TYPES;
var UNINCORPORATED_BUSINESS = 'unincorporated_business';
exports.UNINCORPORATED_BUSINESS = UNINCORPORATED_BUSINESS;
var INCORPORATED_BUSINESS = 'incorporated_business';
exports.INCORPORATED_BUSINESS = INCORPORATED_BUSINESS;
var PARTNERSHIP = 'partnership';
exports.PARTNERSHIP = PARTNERSHIP;
var LIMITED_LIABILITY = 'limited_liability';
exports.LIMITED_LIABILITY = LIMITED_LIABILITY;
var JOINT_VENTURE = 'joint_venture';
exports.JOINT_VENTURE = JOINT_VENTURE;
var SOLE_PROPRIETOR = 'sole_proprietor';
exports.SOLE_PROPRIETOR = SOLE_PROPRIETOR;
PARTY_SUB_TYPES[_types.BUSINESS] = [UNINCORPORATED_BUSINESS, INCORPORATED_BUSINESS, PARTNERSHIP, LIMITED_LIABILITY, JOINT_VENTURE, SOLE_PROPRIETOR];